module.exports = __webpack_public_path__ + "img/banner.68212d4e.jpg";